<app-data-table [configuration]="dataTableConfiguration"></app-data-table>

<ng-template #interactionTableTemplate let-row="row">
  @if (row?.interactions) {
    <app-document-interactions-list [rows]="row.interactions" />
  }
</ng-template>
